<template>
  <div class="postage">
    <b-form @submit.prevent="update">

      <!-- <b-checkbox v-model="settings.enabled" size="sm">Refill enabled</b-checkbox> -->

      <toggle-button
        :color="{checked: '#4da030', unchecked: '#f29fa1'}"
        :switch-color="{checked: '#0c820a', unchecked: '#820a0c'}"
        :value="settings.enabled"
        :width="70"
        :sync="true"
        @change="settings.enabled = !settings.enabled"
        :labels="{checked: 'Active', unchecked: 'Inactive'}"
      />
      <span class="ml-2">
        If active, the settings below will trigger.
      </span>

      <b-row class="mt-2 flex-column">
        <b-col>
          <b-form-group label="Automatically refill postage in the amount of:">
            <money v-model="settings.addAmount" class="form-control" :disabled="!settings.enabled"></money>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="When available postage balance is under:">
            <money v-model="settings.threshold" class="form-control" :disabled="!settings.enabled"></money>
          </b-form-group>
        </b-col>
      </b-row>

      <p class="mt-2">
        Important:<br>
        The available postage balance under amount should be at least 20% of the refill postage amount. <br>
        For example: Refill $500 when under $100 or refill $50 when under $10
      </p>

      <b-btn
        type="submit"
        variant="secondary"
        size="sm"
      >Apply and Submit</b-btn>
    </b-form>
  </div>
</template>

<style lang="scss" scoped>
.postage {
  input {
    font-size: 12px;
    padding: 0 8px !important;
    height: 20px;
    margin-right: 6px;
    width: 90px;
  }
  button {
    background-color: #052360;
    border-color: #052360;
    color: white;
  }
}
</style>

<script>
export default {
  data() {
    return {
      isLoading: false,
      settings: {
        enabled: false,
        addAmount: 0,
        threshold: 0
      }
    };
  },
  created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      try {
        const resp = await axios.get("/refill_settings");
        this.settings = resp.data;
      } catch (e) {
        return;
      }
    },
    async update() {
      if(this.isLoading) {
        return;
      }

      this.isLoading = true;

      try {
        const resp = await axios.post("/refill_settings", this.settings);
        this.settings = resp.data;
        this.$toastr.s("Refill settings saved");
      } catch (e) {
        this.$toastr.e("Failed to save refill settings saved");
      }

      this.isLoading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PostageRefillSettings.vue